import * as betgalaxy from './ResponsibleGambling.styles.betgalaxy';
import * as betprofessor from './ResponsibleGambling.styles.betprofessor';
import * as betroyale from './ResponsibleGambling.styles.betroyale';
import * as fiestabet from './ResponsibleGambling.styles.fiestabet';
import * as goldenrush from './ResponsibleGambling.styles.goldenrush';
import * as juicybet from './ResponsibleGambling.styles.juicybet';
import * as puntcity from './ResponsibleGambling.styles.puntcity';
import * as puntgenie from './ResponsibleGambling.styles.puntgenie';
import * as questbet from './ResponsibleGambling.styles.questbet';
import * as sterlingparker from './ResponsibleGambling.styles.sterlingparker';
import * as vikingbet from './ResponsibleGambling.styles.vikingbet';
import * as volcanobet from './ResponsibleGambling.styles.volcanobet';
import * as wellbet from './ResponsibleGambling.styles.wellbet';
import * as forsport from './ResponsibleGambling.styles.forsport';
import * as junglebet from './ResponsibleGambling.styles.junglebet';
import * as oldgill from './ResponsibleGambling.styles.oldgill';
import * as sugarcastle from './ResponsibleGambling.styles.sugarcastle';
import * as buffalobet from './ResponsibleGambling.styles.buffalobet';
import * as titanbet from './ResponsibleGambling.styles.titanbet';
import * as slambet from './ResponsibleGambling.styles.slambet';
import * as gigabet from './ResponsibleGambling.styles.gigabet';
import * as betstride from './ResponsibleGambling.styles.betstride';
import * as templebet from './ResponsibleGambling.styles.templebet';
import * as goldenbet888 from './ResponsibleGambling.styles.goldenbet888';
import * as hyperbet from './ResponsibleGambling.styles.hyperbet';
import * as bet777 from './ResponsibleGambling.styles.bet777';
import * as chromabet from './ResponsibleGambling.styles.chromabet';
import * as bet575 from './ResponsibleGambling.styles.bet575';
import * as betblast from './ResponsibleGambling.styles.betblast';
import * as pyramidbet from './ResponsibleGambling.styles.pyramidbet';
import * as magnumbet from './ResponsibleGambling.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
